<!--
 * @Author: your name
 * @Date: 2021-09-03 14:04:49
 * @LastEditTime: 2022-03-14 17:52:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\MediaList.vue
-->
<template>
  <msg-dialog :dialogVisible="dialogVisible" @closeDialog="closeDialog" dWidth="700px" :title="$t('PE.AddMultimedia')">
    <div class="add-media">
      <div class="framework">
        <trees type="FILELIST" @getAssets="getAssets" :list="fileList" :select="`${fileId}`"></trees>
      </div>
      <div class="media-list">
        <div class="ml-table">
          <el-table
            :data="mediaList"
            style="width: 100%"
            height="100%"
            :row-key="(row) => row.id"
            @selection-change="mediaSelect"
          >
            <el-table-column type="selection" :selectable="(row)=>row.damaged < 1" width="50" :reserve-selection="true"></el-table-column>
            <el-table-column :label="$t('PE.Thumbnail')" width="120">
              <template slot-scope="scope">
                <div class="operation">
                  <img
                    style="width: 96px; height: 54px;"
                    v-if="scope.row.damaged === 0"
                    :src="scope.row['ref_thumb_url']"
                    alt
                  />
                  <img style="width: 96px; height: 54px;" v-else src="@imgpub/damaged.png" alt />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="ref_name" :label="$t('PE.Name')" show-overflow-tooltip></el-table-column>
            <el-table-column prop="ref_wh" :label="$t('PE.Resolution')"></el-table-column>
          </el-table>
        </div>
        <div class="ml-pagination">
          <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
        </div>
      </div>
    </div>
  </msg-dialog>
</template>

<script>
import MsgDialog from '@/components/basics/MsgDialog'
import trees from '@/components/basics/Trees'
import { mPagination } from "@/components/basics/mixins"
import pagination from '@/components/basics/Pagination'
export default {
  name: 'MediaList',
  mixins: [mPagination],
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      selectMedia: [],
      fileList: [],
      mediaList: [],
      fileId: 1
    }
  },
  created() {
    this.$http.post("/admin/material/mdList", {}, data => {
      this.fileList = data;
      this.getNewMediaList();
    });
  },
  methods: {
    closeDialog(config) {
      if (config) {
        this.$emit('closeDialog', true, this.selectMedia);
      } else {
        this.dialogVisible && this.$emit('closeDialog', false);
      }
    },
    getAssets(ids) {
      if (ids.type === "FILELIST") {
        this.groupId = ids.groupId;
        this.fileId = ids.id;
      }
      this.page = 1;
      this.current = 0;
      this.mediaList = [];
      this.getNewMediaList();
    },
    currentChange(val) {
      this.page = val;
      this.getNewMediaList();
    },
    getNewMediaList(media = {
      dir_id: this.fileId,
      limit: this.limit,
      page: this.page,
    }) {
      this.$http.post("/admin/material/list", media, data => {
        if (data.data && data.data.length > 0) {
          this.mediaList = data.data;
          this.current = data.total;
        } else {
          // this.$msg({ showClose: true, message: '已加载全部资源！', type: 'warning' });
        }
      });
    },
    mediaSelect(val) {
      this.selectMedia = val
    },
  },
  components: {
    MsgDialog,
    trees,
    pagination
  }
}
</script>

<style lang="scss" scoped>
.add-media {
  height: 400px;
  display: flex;
  .framework {
    flex: 0 0 240px;
    border: 1px solid #edfbff;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .media-list {
    flex: 1;
    // background-color: red;
    border-radius: 8px;
    margin-left: 8px;
    display: flex;
    flex-direction: column;
    .ml-table {
      height: calc(100% - 40px);
    }
    .ml-pagination {
      height: 40px;
    }
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: #2fb3ff;
    }
    th:last-child > .cell {
      text-align: center;
    }
  }
}
</style>